import DoneAllIcon from "@mui/icons-material/DoneAll";
import { Checkbox } from "antd";
import { CapsuleTabs, List, Toast } from "antd-mobile";
import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { Button, Card } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import PsContext from "../../context";
import { gethandelBars } from "../../models/pay";
import {
  groupByMultiple,
  momentDate,
  upperCase,
  yearByBatch,
} from "../../utils";
import { ServiceUrl } from "../../utils/serviceUrl";
import Header from "../header";

const ExamFees = (props) => {
  const context = useContext(PsContext);
  const navigate = useNavigate();

  const [loader, setLoader] = useState(false);
  const [validated, setValidated] = useState(false);

  const [dataList, setDataList] = useState([]);
  const [dataView, setDataView] = useState([]);
  const [feeconfig, setFeeConfig] = useState([]);
  const [selectedFeeConfig, setSelectedFeeConfig] = useState([]);
  const [checkPaid, setCheckPaid] = useState([]);
  const [feeconfigView, setFeeConfigView] = useState(false);
  const [feeSubjectView, setFeeSubjectView] = useState(false);
  const [viewPaymentHistoryBtn, setViewPaymentHistoryBtn] = useState(false);
  const [disablePayBtn, setDisablePayBtn] = useState(false);
  const [response, setReponse] = useState([]);
  const currentDate = momentDate(new Date(), "YYYY-MM-DD");
  const [selectedTab, setSelectedTab] = useState(null);
  const [defaultCheckedCount, setDefaultCheckedCount] = useState(0);
  const [paidSubject, setPaidSubject] = useState([]);
  const [nominalSubject, setNominalSubject] = useState([]);
  const [receiptTemplate, setReceiptTemplate] = useState([]);
  const [outputFoilContent, setOutputFoilContent] = useState("");
  const [groupedPaidData, setGroupedPaidData] = useState([]);
  const [examMonth, setExamMonth] = useState(null);
  const [includeRegularSubject, setIncludeRegularSubject] = useState(false);
  const [isPayButtonDisabled, setPayButtonDisabled] = useState(false);

  useEffect(() => {
    if (response && response.access_code)
      document.getElementById("redirect").submit();
  }, [response]);

  const handleDownloadReceipt = (order_id) => {
    let filteredPaidData = checkPaid.filter(
      (item) => item.order_id == order_id
    );

    const compiledTemplate = gethandelBars().compile(
      receiptTemplate[0].template
    );

    let orderData = {
      order_id: filteredPaidData[0].order_id,
      amount: filteredPaidData[0].amount,
      order_date: filteredPaidData[0].paid_date,
      cca_ref_id: filteredPaidData[0].cca_ref_id,
      trans_fee: filteredPaidData[0].trans_fee,
      service_tax: filteredPaidData[0].service_tax,
      exam_month: examMonth,
      net_total:
        parseFloat(filteredPaidData[0].amount) +
        parseFloat(filteredPaidData[0].trans_fee) +
        parseFloat(filteredPaidData[0].service_tax),
    };

    let studentData = {
      name: filteredPaidData[0].name,
      registerno: filteredPaidData[0].registerno,
      batch: filteredPaidData[0].batch,
      course: `${filteredPaidData[0].degreename}-${
        filteredPaidData[0].course_name
      } - (${filteredPaidData[0].coursetype == "regular" ? "R" : "SF"})`,
      semester: filteredPaidData[0].semester,
    };

    let collegeData = {
      college_name: upperCase(context.settingValue("billheader_name")),
    };

    let templateInput = {
      order_data: orderData,
      student_data: studentData,
      subject_data: filteredPaidData,
      college_data: collegeData,
    };
    var output = compiledTemplate(templateInput);
    setOutputFoilContent(output);

    const form = new FormData();
    form.append("preview_content", output);

    axios
      .post(ServiceUrl.STUDENTS.PDF_PREVIEW, form, { responseType: "blob" })
      .then((response) => {
        const pdfUrl = URL.createObjectURL(
          new Blob([response.data], { type: "application/pdf" })
        );
        const link = document.createElement("a");
        link.href = pdfUrl;
        link.setAttribute("download", "Receipt.pdf");
        document.body.appendChild(link);
        link.click();
        link.remove();
        setLoader(false);
      })
      .catch((error) => {
        console.error("Error fetching PDF content:", error);
        setLoader(false);
      });
  };

  useEffect(() => {
    // loadExamFees();
    loadExamFeeConfig();
    loadPrintTemplate();
  }, []);
  //need to remove this api and call template through config
  const loadPrintTemplate = () => {
    context.setLoader(true);
    setReceiptTemplate([]);

    const form = new FormData();
    form.append("group_name", "exam-fee-receipt");
    axios
      .post(ServiceUrl.STUDENTS.GET_FEE_RECEIPT_TEMPLATE, form)
      .then((res) => {
        if (res["data"].status == "1") {
          console.log(res["data"].data);
          setReceiptTemplate(res["data"].data);
        }
        context.setLoader(false);
      });
  };

  const loadExamFeeConfig = () => {
    context.setLoader(true);
    setFeeConfig([]);
    axios.post(ServiceUrl.STUDENTS.EXAM_FEE_CONFIG_LIST).then((res) => {
      if (res["data"].status == "1") {
        console.log(res["data"].data);
        setFeeConfig(res["data"].data);
        setFeeConfigView(true);
      }
      context.setLoader(false);
    });
  };

  const handleOnClick = (event, data) => {
    console.log(data);
    setExamMonth(momentDate(data.exam_month, "MMMM-YYYY"));
    event.preventDefault();
    setSelectedFeeConfig(data);

    loadCheckPaid(data);

    setFeeConfigView(false);
    setViewPaymentHistoryBtn(true);
    // setFeeSubjectView(true);
  };

  const loadCheckPaid = (data) => {
    context.setLoader(true);
    setCheckPaid([]);
    const form = new FormData();
    form.append("student_uuid", context.user.uuid);
    form.append("exam_month", data.exam_month);
    axios
      .post(ServiceUrl.STUDENTS.CHECK_EXAM_FEE_PAID, form)
      .then((checkRes) => {
        if (checkRes["data"].status == "1") {
          setCheckPaid(checkRes["data"].data);
          if (checkRes["data"].data.length == 0) {
            // if there is no datain paid list this will call
            // Here we dont need to validate part payment, bcz check paid has no data
            const endFineDate = momentDate(
              data.nomination_end_date_without_fine,
              "YYYY-MM-DD"
            );

            const endDate = momentDate(data.nomination_end_date, "YYYY-MM-DD");
            if (currentDate > endDate) {
              setDisablePayBtn(true);
              Toast.show("Date Closed");
            } else if (currentDate > endFineDate && currentDate <= endDate) {
              // saveFineAmount(data);
              const fineForm = new FormData();
              fineForm.append("student_uuid", context.user.uuid);
              fineForm.append("fee_amount", feeconfig[0].fine_amount);
              fineForm.append("narration", "fine fee");
              fineForm.append("exam_id", feeconfig[0].exam_id);
              axios
                .post(ServiceUrl.STUDENTS.SAVE_FINE_AMOUNT, fineForm)
                .then((resFine) => {
                  if (resFine["data"].status == "1") {
                    setDataList([]);
                    setDataView([]);
                    const examFeeForm = new FormData();
                    examFeeForm.append("student_uuid", context.user.uuid);
                    examFeeForm.append("exam_month", data.exam_month);
                    examFeeForm.append(
                      "nomination_start_date",
                      data.nomination_start_date
                    );
                    examFeeForm.append(
                      "nomination_end_date",
                      data.nomination_end_date
                    );
                    axios
                      .post(
                        ServiceUrl.STUDENTS.EXAM_FEE_SUBJECT_LIST,
                        examFeeForm
                      )
                      .then((resFee) => {
                        if (resFee["data"].status == "1") {
                          setDataList(resFee["data"].data);
                          setDataView(
                            resFee.data.data.map((item) => ({
                              ...item,
                              checked:
                                data.all_current_arrear_default === "1"
                                  ? item.over_id === null ||
                                    yearByBatch(item.batch)
                                  : item.over_id === null
                                  ? true
                                  : false, // Ensure each item has a 'checked' property
                            }))
                          );
                        }
                        context.setLoader(false);
                      });
                  }
                });
            } else {
              //loadExamFees(data);

              setDataList([]);
              setDataView([]);
              const examFeeForm = new FormData();
              examFeeForm.append("student_uuid", context.user.uuid);
              examFeeForm.append("exam_month", data.exam_month);
              examFeeForm.append(
                "nomination_start_date",
                data.nomination_start_date
              );
              examFeeForm.append(
                "nomination_end_date",
                data.nomination_end_date
              );
              axios
                .post(ServiceUrl.STUDENTS.EXAM_FEE_SUBJECT_LIST, examFeeForm)
                .then((resFee) => {
                  if (resFee["data"].status == "1") {
                    setDataList(resFee["data"].data);
                    setDataView(
                      resFee.data.data.map((item) => ({
                        ...item,
                        checked:
                          data.all_current_arrear_default === "1"
                            ? item.over_id === null || yearByBatch(item.batch)
                            : item.over_id === null
                            ? true
                            : false, // Ensure each item has a 'checked' property
                      }))
                    );
                  }
                  context.setLoader(false);
                });
            }
          } else if (checkRes["data"].data.length > 0) {
            var paidData = checkRes["data"].data;
            var nominalData = [];
            const endFineDate = momentDate(
              data.nomination_end_date_without_fine,
              "YYYY-MM-DD"
            );

            const endDate = momentDate(data.nomination_end_date, "YYYY-MM-DD");

            console.log(currentDate, endFineDate, endDate);

            if (currentDate > endDate) {
              //already paid and date closed
              let groupedPaidDataDateClosed = groupByMultiple(
                paidData,
                function (obj) {
                  return [obj.order_id];
                }
              );

              setGroupedPaidData(groupedPaidDataDateClosed);
              Toast.show("Date Closed");
              setDisablePayBtn(true);
            } else if (currentDate > endFineDate && currentDate <= endDate) {
              //already paid(part or full) need to check
              //if part need to assign fine
              //getting nominal datas

              setDataList([]);
              setDataView([]);
              const examFeeForm = new FormData();
              examFeeForm.append("student_uuid", context.user.uuid);
              examFeeForm.append("exam_month", data.exam_month);
              examFeeForm.append(
                "nomination_start_date",
                data.nomination_start_date
              );
              examFeeForm.append(
                "nomination_end_date",
                data.nomination_end_date
              );
              axios
                .post(ServiceUrl.STUDENTS.EXAM_FEE_SUBJECT_LIST, examFeeForm)
                .then((resFee) => {
                  if (resFee["data"].status == "1") {
                    nominalData = resFee["data"].data;

                    let paidSubjectOnly = paidData.filter(
                      (item) => item.subject_id != null
                    );
                    let nominalSubjectOnly = nominalData.filter(
                      (item) => item.subject_id != null
                    );

                    let arrearPaid = paidSubjectOnly.filter(
                      (item) => item.is_override_exam == "1"
                    );

                    setPaidSubject(paidSubjectOnly);
                    setNominalSubject(nominalSubjectOnly);

                    setDefaultCheckedCount(arrearPaid.length);

                    let unpaidData = nominalData.filter(
                      (nominalItem) =>
                        !paidData.some(
                          (paidItem) =>
                            paidItem.nominal_id === nominalItem.nominal_id
                        )
                    );

                    let currentSub =
                      unpaidData &&
                      unpaidData.length > 0 &&
                      unpaidData.some((item) => item.is_override_exam == "0");

                    if (currentSub) {
                      setIncludeRegularSubject(true);
                    }
                    let groupedPaidData = groupByMultiple(
                      paidData,
                      function (obj) {
                        return [obj.order_id];
                      }
                    );

                    if (
                      (nominalSubjectOnly.length > paidSubjectOnly.length &&
                        arrearPaid.length <
                          feeconfig[0].maximum_arrear_allowed) ||
                      currentSub
                    ) {
                      const fineForm = new FormData();
                      fineForm.append("student_uuid", context.user.uuid);
                      fineForm.append("fee_amount", feeconfig[0].fine_amount);
                      fineForm.append("narration", "fine fee");
                      fineForm.append("exam_id", feeconfig[0].exam_id);
                      axios
                        .post(ServiceUrl.STUDENTS.SAVE_FINE_AMOUNT, fineForm)
                        .then((resFine) => {
                          if (resFine["data"].status == "1") {
                            setDataList([]);
                            setDataView([]);
                            const examFeeFormwithFine = new FormData();
                            examFeeFormwithFine.append(
                              "student_uuid",
                              context.user.uuid
                            );
                            examFeeFormwithFine.append(
                              "exam_month",
                              data.exam_month
                            );
                            examFeeFormwithFine.append(
                              "nomination_start_date",
                              data.nomination_start_date
                            );
                            examFeeFormwithFine.append(
                              "nomination_end_date",
                              data.nomination_end_date
                            );
                            axios
                              .post(
                                ServiceUrl.STUDENTS.EXAM_FEE_SUBJECT_LIST,
                                examFeeFormwithFine
                              )
                              .then((resFee) => {
                                if (resFee["data"].status == "1") {
                                  nominalData = resFee["data"].data;

                                  let paidSubjectOnlywithFine = paidData.filter(
                                    (item) => item.subject_id != null
                                  );
                                  let nominalSubjectOnlywithFine =
                                    nominalData.filter(
                                      (item) => item.subject_id != null
                                    );

                                  let arrearPaidwithFine =
                                    paidSubjectOnlywithFine.filter(
                                      (item) => item.is_override_exam == "1"
                                    );

                                  setPaidSubject(paidSubjectOnlywithFine);
                                  setNominalSubject(nominalSubjectOnlywithFine);

                                  setDefaultCheckedCount(
                                    arrearPaidwithFine.length
                                  );

                                  let unpaidDatawithFine = nominalData.filter(
                                    (nominalItem) =>
                                      !paidData.some(
                                        (paidItem) =>
                                          paidItem.nominal_id ===
                                          nominalItem.nominal_id
                                      )
                                  );

                                  let groupedPaidDatawithFine = groupByMultiple(
                                    paidData,
                                    function (obj) {
                                      return [obj.order_id];
                                    }
                                  );

                                  setGroupedPaidData(groupedPaidDatawithFine);
                                  setDataList(unpaidDatawithFine);
                                  setDataView(
                                    unpaidDatawithFine.map((item) => ({
                                      ...item,
                                      checked:
                                        data.all_current_arrear_default === "1"
                                          ? item.over_id === null ||
                                            yearByBatch(item.batch)
                                          : item.over_id === null
                                          ? true
                                          : false, // Ensure each item has a 'checked' property
                                    }))
                                  );
                                }
                                context.setLoader(false);
                              });
                          }
                        });
                    } else {
                      setGroupedPaidData(groupedPaidData);
                      setDataList(unpaidData);
                      setDataView(
                        unpaidData.map((item) => ({
                          ...item,
                          checked:
                            data.all_current_arrear_default === "1"
                              ? item.over_id === null || yearByBatch(item.batch)
                              : item.over_id === null
                              ? true
                              : false, // Ensure each item has a 'checked' property
                        }))
                      );
                    }
                  }
                  context.setLoader(false);
                });
            } else {
              //console.log("testttt");
              //getting nominal datas
              setDataList([]);
              setDataView([]);
              const examFeeForm = new FormData();
              examFeeForm.append("student_uuid", context.user.uuid);
              examFeeForm.append("exam_month", data.exam_month);
              examFeeForm.append(
                "nomination_start_date",
                data.nomination_start_date
              );
              examFeeForm.append(
                "nomination_end_date",
                data.nomination_end_date
              );
              axios
                .post(ServiceUrl.STUDENTS.EXAM_FEE_SUBJECT_LIST, examFeeForm)
                .then((resFee) => {
                  if (resFee["data"].status == "1") {
                    nominalData = resFee["data"].data;

                    let paidSubjectOnly = paidData.filter(
                      (item) => item.subject_id != null
                    );
                    let nominalSubjectOnly = nominalData.filter(
                      (item) => item.subject_id != null
                    );

                    let arrearPaid = paidSubjectOnly.filter(
                      (item) => item.is_override_exam == "1"
                    );

                    setPaidSubject(paidSubjectOnly);
                    setNominalSubject(nominalSubjectOnly);

                    setDefaultCheckedCount(arrearPaid.length);
                    //setDefaultCheckedCount(6);

                    let unpaidData = nominalData.filter(
                      (nominalItem) =>
                        !paidData.some(
                          (paidItem) =>
                            paidItem.nominal_id === nominalItem.nominal_id
                        )
                    );
                    console.log(unpaidData);
                    //check atleast one current subject in unpaid list, if yes means open paynow page
                    let currentSub =
                      unpaidData &&
                      unpaidData.length > 0 &&
                      unpaidData.some((item) => item.is_override_exam == "0");

                    if (currentSub) {
                      setIncludeRegularSubject(true);
                    }

                    let groupedPaidData = groupByMultiple(
                      paidData,
                      function (obj) {
                        return [obj.order_id];
                      }
                    );

                    setGroupedPaidData(groupedPaidData);
                    setDataList(unpaidData);
                    setDataView(
                      unpaidData.map((item) => ({
                        ...item,
                        checked:
                          data.all_current_arrear_default === "1"
                            ? item.over_id === null || yearByBatch(item.batch)
                            : item.over_id === null
                            ? true
                            : false, // Ensure each item has a 'checked' property
                      }))
                    );
                  }
                  context.setLoader(false);
                });
            }
          }
        }
        context.setLoader(false);
      });
  };

  /*  const saveFineAmount = (data) => {
    context.setLoader(true);
    const form = new FormData();
    form.append("student_uuid", context.user.uuid);
    form.append("fee_amount", feeconfig[0].fine_amount);
    form.append("narration", "fine fee");
    form.append("exam_id", feeconfig[0].exam_id);

    axios
      .post(ServiceUrl.STUDENTS.SAVE_FINE_AMOUNT, form)
      .then((res) => {
        if (res.data.status === "1") {
          loadExamFees(data);
        }
      })
      .catch((error) => {
        Toast.show({ content: error.message || "An error occurred" });
      })
      .finally(() => {
        context.setLoader(false);
      });
  }; */

  /* const loadExamFees = (data) => {
    context.setLoader(true);
    setDataList([]);
    setDataView([]);
    const form = new FormData();
    form.append("student_uuid", context.user.uuid);
    form.append("exam_month", data.exam_month);
    form.append("nomination_start_date", data.nomination_start_date);
    form.append("nomination_end_date", data.nomination_end_date);
    axios.post(ServiceUrl.STUDENTS.EXAM_FEE_SUBJECT_LIST, form).then((res) => {
      if (res["data"].status == "1") {
        setDataList(res["data"].data);
        setDataView(
          res.data.data.map((item) => ({
            ...item,
            checked:
              data.all_current_arrear_default === "1"
                ? item.over_id === null || yearByBatch(item.batch)
                : item.over_id === null
                ? true
                : false, // Ensure each item has a 'checked' property
          }))
        );
      }
      context.setLoader(false);
    });
  }; */

  const handlePaySubmit = (e) => {
    e.preventDefault();
    setPayButtonDisabled(true);
    context.setLoader(true);
    const form = new FormData();
    var d = dataView.filter((item) => item.checked === true);
    form.append("nominal_ids", d.map((item) => item.nominal_id).join(","));
    form.append("amount", totalFee);
    form.append("exam_fee_config", feeconfig[0].id);
    form.append("merchant_id", feeconfig[0].merchant_id);
    form.append("working_key", feeconfig[0].working_key);
    form.append("access_code", feeconfig[0].access_code);
    form.append("student_uuid", context.user.uuid);

    axios
      .post(ServiceUrl.STUDENTS.EXAM_FEE_PAYMENT, form)
      .then((res) => {
        if (res.data.status === "1") {
          console.log(res.data.data);
          setReponse(res.data.data);
        } else {
          Toast.show({ content: res.data.message || "Error" });
        }
      })
      .catch((error) => {
        Toast.show({ content: error.message || "An error occurred" });
      })
      .finally(() => {
        context.setLoader(false);
      });
  };

  const handleCheckboxChange = (index, checked) => {
    const newItems = [...dataView];

    /*   if (newItems[index]) {
      newItems[index].checked = checked;
    }
    console.log(newItems);

    setDataView(newItems); */
    if (checked) {
      console.log(
        "checked items",
        newItems.filter((ii) => ii.over_id !== null && ii.checked),
        parseInt(feeconfig[0].maximum_arrear_allowed)
      );

      console.log("config-check", feeconfig[0].maximum_arrear_allowed, checked);
      if (
        newItems.filter((ii) => ii.over_id !== null && ii.checked).length <
        parseInt(feeconfig[0].maximum_arrear_allowed)
      ) {
        if (newItems[index]) {
          newItems[index].checked = checked;
        }
        console.log(newItems);

        setDataView(newItems);
      } else
        Toast.show(
          " maximum selecttion allowed is : " +
            feeconfig[0].maximum_arrear_allowed
        );
    } else {
      if (newItems[index]) {
        newItems[index].checked = checked;
      }
      console.log(newItems);

      setDataView(newItems);
    }
  };

  const totalFee = dataView
    .filter((item) => {
      const isDisabled =
        selectedFeeConfig.all_current_arrear_default === "1"
          ? item.over_id === null || yearByBatch(item.batch)
          : item.over_id === null;
      return isDisabled || item.checked;
    })
    .reduce((acc, item) => acc + parseFloat(item.fee_amount) || 0, 0);

  return (
    <>
      <Header title="Exam Fees" backAction={true} rightActions={[]} />
      <div className=" ">
        <div className="container-sm py-md-3">
          {feeconfigView && feeconfig && feeconfig.length > 0 && (
            <>
              <Card data-aos="zoom-in">
                <Card.Header className="card-header-bg text-uppercase fw-bold">
                  Exam Fee Payment
                </Card.Header>
                <Card.Body>
                  <div className="mt-3">
                    {feeconfig.map((item, index) => {
                      // Convert exam month into a human-readable format
                      const examDate = new Date(item.exam_month);
                      const formattedExamMonth = examDate.toLocaleDateString(
                        "en-US",
                        {
                          year: "numeric",
                          month: "short",
                        }
                      );

                      return (
                        <div
                          key={index}
                          style={{
                            textAlign: "center",
                            marginBottom: "20px",
                          }}
                        >
                          <a
                            href="#"
                            style={{
                              fontSize: "24px", // Bigger font size
                              fontWeight: "bold", // Bold text
                              color: "blue", // Optional: black color
                              textDecoration: "underline", // Remove underline
                            }}
                            onClick={(e) => handleOnClick(e, item)}
                          >
                            {formattedExamMonth}
                          </a>
                        </div>
                      );
                    })}
                  </div>
                </Card.Body>
              </Card>
            </>
          )}
          {viewPaymentHistoryBtn && (
            <Card>
              <Card.Header className="card-header-bg text-uppercase fw-bold">
                Payment
              </Card.Header>
              <Card.Body>
                <CapsuleTabs
                  activeKey={selectedTab}
                  onChange={(key) => {
                    setSelectedTab(key);
                  }}
                >
                  {!disablePayBtn && (
                    <CapsuleTabs.Tab title="Pay Now" key="pay_now">
                      {selectedTab === "pay_now" && (
                        <>
                          {checkPaid.length > 0 &&
                          (nominalSubject.length == paidSubject.length ||
                            defaultCheckedCount ==
                              feeconfig[0].maximum_arrear_allowed) &&
                          !includeRegularSubject ? (
                            // Display this message when fees have already been paid
                            <h5
                              style={{
                                textAlign: "center",
                                paddingTop: "20px",
                              }}
                            >
                              <div className="alert alert-success bg-green-50">
                                <DoneAllIcon className="me-2" />
                                Fees Already Paid
                              </div>
                            </h5>
                          ) : dataView && dataView.length > 0 ? (
                            <>
                              <Card data-aos="zoom-in">
                                <Card.Body>
                                  <div className="mt-3">
                                    <List>
                                      {dataView.map((item, index) => {
                                        const isDisabled =
                                          selectedFeeConfig.all_current_arrear_default ===
                                          "1"
                                            ? item.over_id === null ||
                                              yearByBatch(item.batch)
                                            : item.over_id === null;
                                        return (
                                          <List.Item
                                            key={index} // Using index instead of i
                                            style={
                                              item.over_id !== null
                                                ? { backgroundColor: "#ffdde2" }
                                                : {}
                                            }
                                            prefix={
                                              <Checkbox
                                                checked={item.checked}
                                                disabled={isDisabled}
                                                onChange={(e) =>
                                                  handleCheckboxChange(
                                                    index,
                                                    e.target.checked
                                                  )
                                                }
                                              />
                                            }
                                            extra={<>Rs. {item.fee_amount}</>}
                                          >
                                            {item.subject_id
                                              ? `${item.subject_name} (${item.subject_code})`
                                              : item.narration}
                                          </List.Item>
                                        );
                                      })}

                                      <List.Item>
                                        <div
                                          style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                            width: "100%",
                                          }}
                                        >
                                          <strong>
                                            Total fee : Rs.{" "}
                                            {totalFee.toFixed(2)}
                                          </strong>
                                          <Button
                                            type="submit"
                                            variant="success"
                                            className="mx-1"
                                            style={{ width: "104px" }}
                                            disabled={isPayButtonDisabled}
                                            onClick={handlePaySubmit}
                                          >
                                            <i className="fa-solid fa-check me-2"></i>
                                            Pay Now
                                          </Button>
                                        </div>
                                      </List.Item>
                                    </List>
                                  </div>

                                  {checkPaid.length > 0 && (
                                    <Card data-aos="zoom-in" className="mt-3">
                                      <Card.Body>
                                        <div className="mt-3">
                                          <h5>Paid Data</h5>
                                          <List>
                                            {checkPaid.map(
                                              (paidItem, index) => (
                                                <List.Item
                                                  key={index}
                                                  style={{
                                                    backgroundColor: "#dff0d8",
                                                  }} // Different background for paid data
                                                >
                                                  <span>
                                                    {paidItem.subject_name
                                                      ? `${paidItem.subject_name} (${paidItem.subject_code})`
                                                      : paidItem.narration}
                                                  </span>
                                                </List.Item>
                                              )
                                            )}

                                            <List.Item>
                                              <strong>
                                                Total Paid Amount: Rs.{" "}
                                                {checkPaid[0].amount}
                                              </strong>
                                            </List.Item>
                                          </List>
                                        </div>
                                      </Card.Body>
                                    </Card>
                                  )}
                                </Card.Body>
                              </Card>
                            </>
                          ) : (
                            <h5
                              style={{
                                textAlign: "center",
                                paddingTop: "20px",
                              }}
                            >
                              <strong>
                                <span style={{ color: "blue" }}>No Exams</span>
                              </strong>
                            </h5>
                          )}
                        </>
                      )}
                    </CapsuleTabs.Tab>
                  )}
                  <CapsuleTabs.Tab
                    title="Payment History"
                    key="payment_history"
                  >
                    {groupedPaidData.length > 0 ? (
                      <div>
                        <table
                          style={{
                            width: "100%",
                            borderCollapse: "collapse",
                          }}
                        >
                          <thead>
                            <tr>
                              <th
                                style={{
                                  textAlign: "left",
                                  padding: "8px",
                                  border: "1px solid #ddd",
                                }}
                              >
                                Order No
                              </th>
                              <th
                                style={{
                                  textAlign: "left",
                                  padding: "8px",
                                  border: "1px solid #ddd",
                                }}
                              >
                                Amount
                              </th>
                              <th
                                style={{
                                  textAlign: "left",
                                  padding: "8px",
                                  border: "1px solid #ddd",
                                }}
                              >
                                Download
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {groupedPaidData.map((group, index) => (
                              <tr key={index}>
                                <td
                                  style={{
                                    padding: "8px",
                                    border: "1px solid #ddd",
                                  }}
                                >
                                  <span>{group[0]?.order_id}</span>
                                </td>
                                <td
                                  style={{
                                    padding: "8px",
                                    border: "1px solid #ddd",
                                  }}
                                >
                                  <span>{group[0]?.amount}</span>
                                </td>
                                <td
                                  style={{
                                    padding: "8px",
                                    border: "1px solid #ddd",
                                    textAlign: "center", // Centers horizontally
                                  }}
                                >
                                  <Button
                                    variant="primary"
                                    style={{ marginTop: "10px" }} // Adding space between total and button
                                    onClick={() =>
                                      handleDownloadReceipt(group[0]?.order_id)
                                    }
                                  >
                                    <i className="fas fa-download"></i>
                                  </Button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    ) : (
                      <div className="alert alert-danger bg-red-50">
                        No payment history available.
                      </div>
                    )}
                  </CapsuleTabs.Tab>
                </CapsuleTabs>
              </Card.Body>
            </Card>
          )}
        </div>
      </div>

      {response && response.access_code && (
        <form
          method="post"
          name="redirect"
          id="redirect"
          action="https://secure.ccavenue.com/transaction/transaction.do?command=initiateTransaction"
        >
          <input type="hidden" name="encRequest" value={response.reqdata} />
          <input
            type="hidden"
            name="access_code"
            value={response.access_code}
          />
        </form>
      )}
    </>
  );
};
export default ExamFees;
